import { createSlice } from "@reduxjs/toolkit";
import { resolveApiMessage } from "../../helpers/apiMessage";
import { getWifiInfo, updateWifiInfo } from "./thunk";

const getErrorMessage = (payload: any): string => {
    if (!payload) return resolveApiMessage(payload);
    if (typeof payload === "string") return payload;
    if (typeof payload === "object") {
        if (typeof payload.message === "string") return payload.message;
        if (typeof payload.errors === "string") return payload.errors;
    }
    return resolveApiMessage(payload);
};

const getShopData = (payload: any): any => {
    const body = payload?.response?.data ?? payload?.data ?? payload;
    return body?.data ?? body ?? null;
};

const ShopWifiSlice = createSlice({
    name: "ShopWifi",
    initialState: {
        shop: null as any,
        loading: false,
        error: null as string | null,
        updating: false,
        updateError: null as string | null,
        updateSuccess: false,
    },
    reducers: {
        clearShopWifiState(state) {
            state.updateError = null;
            state.updateSuccess = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getWifiInfo.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getWifiInfo.fulfilled, (state, action) => {
            state.loading = false;
            state.shop = getShopData(action.payload);
        });
        builder.addCase(getWifiInfo.rejected, (state, action) => {
            state.loading = false;
            state.error = getErrorMessage(action.payload);
        });
        builder.addCase(updateWifiInfo.pending, (state) => {
            state.updating = true;
            state.updateError = null;
            state.updateSuccess = false;
        });
        builder.addCase(updateWifiInfo.fulfilled, (state, action) => {
            state.updating = false;
            state.updateSuccess = true;
            const updated = getShopData(action.payload);
            if (updated) {
                state.shop = updated;
            }
        });
        builder.addCase(updateWifiInfo.rejected, (state, action) => {
            state.updating = false;
            state.updateError = getErrorMessage(action.payload);
        });
    },
});

export const { clearShopWifiState } = ShopWifiSlice.actions;
export default ShopWifiSlice.reducer;
